import React from "react";
import CalendarioPage from "../pages/CalendarioPage";

const CalendarioRoutes = () => {
  return (
      <CalendarioPage />
  );
};

export default CalendarioRoutes;
